import { createSlice } from '@reduxjs/toolkit'

import { fetchLocations } from 'redux/thunks/Locations'

type Locations = {
  [key: string]: string
  location: string
}

interface InitialLocatonsDataType {
  data: Locations[]
  fetching: boolean
  doneFetching: boolean
  fetchError: string
}

const initialState: InitialLocatonsDataType = {
  data: [],
  fetching: false,
  doneFetching: false,
  fetchError: '',
}

export const location = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLocations.pending.toString()]: (state) => {
      state.fetching = true
    },
    [fetchLocations.fulfilled.toString()]: (state, action) => {
      state.data = action.payload
      state.fetching = false
      state.doneFetching = true
    },
    [fetchLocations.rejected.toString()]: (state, action) => {
      state.fetching = false
      state.fetchError = action.payload
      state.doneFetching = false
    },
  },
})

export default location.reducer
